import { render, staticRenderFns } from "./ProjectVersions.vue?vue&type=template&id=1c929d9e&scoped=true&"
import script from "./ProjectVersions.vue?vue&type=script&lang=ts&"
export * from "./ProjectVersions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c929d9e",
  null
  
)

export default component.exports